const prontoPagoData = {
  name: 'pronto pago',
  titleText: '¿Quieres fortalecer tu relación con proveedores sin afectar tu caja?',
  subtitleText: 'Con Pronto Pago de Fingo puedes ofrecer pagos anticipados a tus proveedores, sin cambiar tus plazos de pago. '
  + 'Ellos reciben el dinero antes, tú mantienes tu flujo de caja y Fingo gestiona todo por ti.',
  startTextButton: 'Contactar ejecutivo',
  hero_image: '/images/pronto_pago_hero.webp',
  description_information: {
    image: '/images/pronto_pago_description.webp',
    title: '¿Qué es el Pronto Pago?',
    text: 'Pronto Pago es una solución que te permite ofrecer a tus proveedores la posibilidad de adelantar el pago de sus facturas antes de la fecha de vencimiento, a través de un convenio con Fingo. '
    + 'En lugar de esperar 30, 60 o más días, tus proveedores pueden recibir el dinero de forma anticipada, mientras tú mantienes tus plazos de pago originales. '
    + 'Es una forma efectiva de fortalecer la cadena de suministro, construir relaciones más confiables y mejorar tu reputación como pagador sin afectar tu flujo de caja.',
  },
  benefits_information: {
    image: '/images/pronto_pago_benefits.webp',
    title: 'Beneficios de operar con Fingo',
    text: [
      'El proceso es simple, digital y sin fricciones para ambas partes.',
      'Reduce la presión financiera en tus proveedores, ayudándolos a operar mejor y con menos riesgo.',
      'Fingo se encarga del financiamiento y del proceso completo, tú solo validas las facturas.',
      'Fortalece la relación con proveedores clave al ofrecerles mayor liquidez y estabilidad.',
    ],
  },
};

export default prontoPagoData;
